import { httpService } from './http.service';
import { API_ENDPOINTS } from '../config/api.config';

class DemandeDetailsService {
  /**
   * Récupérer les détails d'une demande
   * @param {number} demandeId - ID de la demande
   * @returns {Promise<Object>} - Détails de la demande
   */
  async getDemandeDetails(demandeId) {
    try {
      const response = await httpService.get(API_ENDPOINTS.DEMANDES.DETAIL(demandeId));
      console.log('Détails de la demande récupérés:', response);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error(`Erreur lors de la récupération de la demande ${demandeId}:`, error);
      return {
        success: false,
        error: error.message,
      };
    }
  }
}

export const demandeDetailsService = new DemandeDetailsService();
export default demandeDetailsService;